import { useEffect, useRef } from 'react'

const FIVE_MINUTES = 5 * 60 * 1000

/**
 * Calls a callback on a fixed interval. Cleans up on unmount.
 */
export function usePollingInterval(callback, intervalMs = FIVE_MINUTES, enabled = true) {
  const savedCallback = useRef(callback)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    if (!enabled) return

    const id = setInterval(() => {
      savedCallback.current()
    }, intervalMs)

    return () => clearInterval(id)
  }, [intervalMs, enabled])
}
